
/**
 * @name ContractsWithPartialPayments.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\ContractsWithPartialPayments.js
 */

//import { apiCall, getBaseDir } from './utils.js';

import TableBuilder from '../../table_builder.js';
import Swal from 'sweetalert2';
import moment from 'moment-timezone';
var getBaseDir = null, apiCall = null, getBranchNameFromId = null, float2moeda = null, userHasRole = null, getContractStatusName = null;

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;
        float2moeda = utils.float2moeda;
        userHasRole = utils.userHasRole;
        getContractStatusName = utils.getContractStatusName;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'financeiro/pagamentos-parciais-manutencao')
            return;

        new ContractsPartialPayments(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class ContractsPartialPayments
{
    constructor(onloadList=false, deps = {})
    {
        
        this.deps = deps;
        this.businessPlans = [];
        let self = this;
        this.tableHandler = new TableBuilder({
            table: '#table-partial-contracts-list',
            tableBody: '.js-partial-contracts-registrations-table',
            data: [],
            rowsPerPage: parseInt($('.js-partial-contracts-per-page option:selected').val()),
            filter: false,
            maxPages: 0,
            customId: "CrudPartialContractsHandler",
            tableRowRenderer: function(rowData) {
                return self.mountTableRow(rowData);
            },
            OnClickFirstPage: function() {
                self.fetchPartialContractsList();
            },
            OnClickLastPage: function() {
                self.fetchPartialContractsList();
            },
        });

        $(".js-partial-contracts-registrations-conntainer").block(window._loader.loading);

        // Resgata lista de planos
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/plans',
            successCallback: function(res) {
                if (!res.error) {
                    $(".js-partial-contracts-registrations-conntainer").unblock();

                    self.businessPlans = res.data;
                    self.fetchPartialContractsList();
                }
            },
            errorCallback: function(err) {
            }
        });
        
        
        this.bindDomTableAndFilterEvents();
        this.bindDomEvents();
    }

    fetchPartialContractsList() {
        let self = this;
        $(".js-partial-contracts-registrations-table").block(window._loader.loading);
        if (this.fetchRequest) {
            if (typeof this.fetchRequest.abort === 'function')
                this.fetchRequest.abort();
            this.fetchRequest = null;
        }
        this.fetchRequest =apiCall({
            method: 'GET',
            endpoint: 'api/v1/contracts',
            data: {
                search: self.searchQuery,
                page: self.tableHandler.getCurrentPage(),
                recordsPerPage: parseInt($('.js-partial-contracts-per-page option:selected').val()),
                contractWithPartialPayments: true,
                ...self.selectedBranch !== -1 ? { branchId: self.selectedBranch } : {},
                ...self.startDate !== null && self.endDate !== null ? { startDate: self.startDate, endDate: self.endDate } : {},
                ...self.serviceId !== '' && self.serviceId !== null ? { serviceId: self.serviceId } : {},
                ...self.status !== '' && self.status !== null ? { status: self.status } : {}
            },
            successCallback: function(res) {
                $(".js-partial-contracts-registrations-table").unblock();
                if (!res.error) {
                    self.partialContractsList = res.data;
                    self.partialContractsTotal = res.total;
                    self.tableHandler.renderPage(self.tableHandler.getCurrentPage(), false, self.partialContractsList, false, self.partialContractsTotal);
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function(err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    mountTableRow = (courtesy) => {
        let findPlan = this.businessPlans.find(plan => plan.ID == courtesy.PLANOS_ID);
        let row = `
            <tr>
                <td data-label="Ações">
                    <button class="btn btn-sm btn-primary m-1 js-contract-parcels-toggler js-contract-parcels-btn-${courtesy.ID}" data-contract-id="${courtesy.ID}" data-branch-id="${courtesy.FILIAL_ID}" data-info='${JSON.stringify(courtesy)}'><i class="fas fa-chevron-right"></i></button>
                    ${userHasRole('ADMIN') || userHasRole('ADMIN_ASSISTANT') ? `<button class="btn btn-sm btn-primary m-1 js-view-contract-parcels-modal" data-info='${JSON.stringify(courtesy)}'><i class="fas fa-edit"></i></button>` : ''}
                </td>
                <td data-label="ID">${courtesy.ID}</td>
                <td data-label="Cliente">${courtesy.CLIENTE_NOME}</td>
                <td data-label="Plano">${findPlan.DESCRICAO}</td>
                <td data-label="Data Adesão">${moment(courtesy.DATA_ADESAO_FORMATTED).format("DD/MM/YYYY")}</td>
                <td data-label="Data Encerramento">${moment(courtesy.DATA_ENCERRAMENTO_FORMATTED).format("DD/MM/YYYY")}</td>
                <td data-label="Total Contrato">${float2moeda(courtesy.TOTAL_PLANO - courtesy.DESCONTO_VALOR)}</td>
                <td data-label="Status">${getContractStatusName(courtesy.STATUS)}</td>
                <td data-label="Qt. Parcela">${courtesy.QT_PARCELAS_NAO_PAGAS ?? 0}</td>
            </tr>
            <!-- lista de parcelas -->
            <tr class="js-contract-parcels-${courtesy.ID} d-none" data-contract-id="${courtesy.ID}">
                <td colspan="11" class="js-contract-parcels-list-${courtesy.ID}">
                    <!-- spinner -->
                    <div class="d-flex justify-content-center">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden">Carregando...</span>
                        </div>
                    </div>
                </td>
            </tr>
        `;

        return row;
    }

    bindDomTableAndFilterEvents() {
        let self = this;
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = $(this).text();
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchPartialContractsList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-previous-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() - 1; //console.log('previous pageId', pageId);
            if (pageId <= 0)
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchPartialContractsList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-next-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() + 1; //console.log('next pageId', pageId);
            if (pageId > self.tableHandler.getMaxPages())
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchPartialContractsList();
        });

        // Detecta usuário mudando de filial para buscar paciente
        $('.js-partial-contracts-branches-selector').change(function() {
            self.selectedBranch = $(this).val();
            // Caso tenha selecinado uma filial, mostra o campo para buscar pelo nome do paciente
            if (self.selectedBranch != '') {
                self.fetchPartialContractsList();
            } else {
                self.selectedBranch = -1;
            }
        });

        // Detecta usuário buscando pelo nome do paciente
        $('#js-partial-contracts-search-input').on('input', function() {
            // make a typing debounce
            clearTimeout(self.searchQueryTimeout);
            self.searchQueryTimeout = setTimeout(function() {
                self.searchQuery = $('#js-partial-contracts-search-input').val().trim();
                if (self.searchQuery.length > 3) {
                    self.fetchPartialContractsList();
                } else if (self.searchQuery.length == 0) {
                    self.searchQuery = '';
                    self.fetchPartialContractsList();
                }
            }, 500);
        })

        // Detecta usuário configurando filtro de data de adesão
        $(document).on('change', '.js-partial-contracts-start-date-input', function(e) {
            self.startDate = $(this).val();
            if (self.startDate === '')
                self.startDate = null;
            self.fetchPartialContractsList();
        });

        // Detecta usuário configurando filtro de data de adesão
        $(document).on('change', '.js-partial-contracts-end-date-input', function(e) {
            self.endDate = $(this).val();
            if (self.endDate === '')
                self.endDate = null;
            self.fetchPartialContractsList();
        });

        // Detecta usuário configurando status do contrato
        $(document).on('change', '.js-partial-contracts-status-list', function() {
            self.status = $(this).val();
            self.fetchContractsList();
        });

        // Detecta usuário configurando filtro qtd de registros por página
        $(document).on('change', '.js-partial-contracts-per-page', function() {
            self.tableHandler.setRowsPerPage(parseInt($(this).val()));
            self.tableHandler.setCurrentPage(1);
            self.fetchPartialContractsList();
        });
    }

    bindDomEvents() {
        let self = this;

        // Detecta usuário clicando para abrir visualização das parcelas
        $(document).on('click', '.js-contract-parcels-toggler', function() {
            let contractId = $(this).data('contract-id');
            let branchId = $(this).data('branch-id');
            // open tr with sessions
            $(`.js-contract-parcels-${contractId}`).toggleClass('d-none');
            if ($(`.js-contract-parcels-${contractId}`).hasClass('d-none')) {
                $(`.js-contract-parcels-btn-${contractId}`).html(`<i class="fas fa-chevron-right"></i>`);
                $(`js-contract-parcels-list-${contractId}`).html(`
                    <!-- spinner -->
                    <div class="d-flex justify-content-center">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden">Carregando...</span>
                        </div>
                    </div>
                `);
            } else {
                self.fetchContractInstallments(contractId);
                $(`.js-contract-parcels-btn-${contractId}`).html(`<i class="fas fa-chevron-down"></i>`);
                $(`.js-contract-parcels-btn-${contractId}`).prop('disabled', true);
            }
        });

        // Detecta usuário clicando para abrir visualização das parcelas
        $(document).on('click', '.js-view-contract-parcels-modal', function() {
            let courtesy = $(this).data('info');
            console.log('courtesy', courtesy);
            self.selectedContractAdvancedUpdates = courtesy;
            self.fetchContractInstallments(courtesy.ID, true);
            $("#modal-financial-contract-parcels").modal('show');
        });

        // Detecta usuário clicando para salvar alterações nas parcelas
        $(document).on('click', '.js-financial-contract-parcel-save-updates', function() {

            // loop trought all inputs and get the parcel id
            let parcelsData = [];
            $('.js-financial-contract-installments-list tr').each(function() {
                let parcelId = $(this).find('td').eq(0).text();
                if (parcelId !== '') {
                    let paymentMethod = $(this).find('#contract_financial_installments_payment_method').val();
                    let paymentDate = $(this).find('#contract_financial_installments_payment_date').val();
                    let paymentNumber = $(this).find('#contract_financial_installments_number').val();
                    let paymentTotal = $(this).find('#contract_financial_installments_total').val();
                    let paymentValue = $(this).find('#contract_financial_installments_value').val();
                    let paymentObs = $(this).find('#contract_financial_installments_obs').val();
                    let paymentPaid = $(this).find('#contract_financial_installments_paid').val();

                    if (paymentMethod === '' || paymentDate === '' || paymentNumber === '' || paymentTotal === '' || paymentValue === '' || paymentPaid === '') {
                    } else {
                        parcelsData.push({
                            parcelId: parcelId,
                            paymentMethod: paymentMethod,
                            paymentDate: paymentDate,
                            paymentNumber: paymentNumber,
                            paymentTotal: paymentTotal,
                            paymentValue: paymentValue,
                            paymentObs: paymentObs,
                            paymentPaid: paymentPaid
                        });
                    }
                
                }
            });

            console.log('parcelsData', parcelsData);

            // block form
            $(".js-financial-contract-installments-form").block(window._loader.loading);

            Swal.fire({
                title: 'Deseja realmente atualizar as parcelas?',
                text: 'Essa ação não poderá ser desfeita',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    self.updateContractInstallments(self.selectedContractAdvancedUpdates.ID, parcelsData);
                } else {
                    $(".js-financial-contract-installments-form").unblock();
                }
            });
        });

        // Detecta usuário clicando para inserir parcela
        $(document).on('submit', '.js-financial-contract-installments-form', function(e) {
            e.preventDefault();
            let serializeData = $(this).serializeArray();
            $(".modal-financial-contract-installments-dialog").block(window._loader.loading);

            let selfBtn = this;
            $(selfBtn).find('button[type="submit"]').prop('disabled', true);

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/patient/contract/insert_installment',
                data: serializeData,
                successCallback: function(res) {
                    $(".modal-financial-contract-installments-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                    
                    window.toast({
                        error: res.error,
                        text: res.message
                    })

                    if (!res.error) {
                        $('.js-financial-contract-installments-form').trigger('reset');
                        $('#contract_advanced_insert_installments_contract_id').val(self.selectedContractAdvancedUpdates.ID);
                        $('#modal-financial-contract-installments').modal('hide');
                        self.fetchContractInstallments(self.selectedContractAdvancedUpdates.ID);
                    }
                },
                errorCallback: function(err) {
                    $(".modal-financial-contract-installments-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                }
            })
        });

        // Detecta alteração de valor total da parcela e atualiza o valor da parcela
        $(document).on('change', 'input[name="contract_financial_installments_total"]', function() {
            let total = $(this).val();
            let parcelId = $(this).data('parcel-id');
            let value = parseFloat(total);
            $(`#contract_financial_installments_value[data-parcel-id="${parcelId}"]`).val(value);
        });
    }

    fetchContractInstallments(contract_id, isModal=false) {
        $("#contract_financial_installments_contract_id").val(contract_id);
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/patient/contract/installments',
            data: {
                contractId: contract_id
            },
            successCallback: function(res) {
                $('.modal-marketing-transfer-lead-dialog').unblock();
                if (!res.error) {
                    let tableHtml = '';

                    if (!isModal) {
                        tableHtml = `<table class="table table-bordered table-striped table-hover responsive-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Forma Pgto</th>
                                    <th>Qt Parcelas</th>
                                    <th>Vlr Parcela</th>
                                    <th>Data Pagamento</th>
                                    <th>Parcela Paga?</th>
                                </tr>
                            </thead>
                            <tbody class="js-contract-parcels-list-table-content-${contract_id}">
                                <tr><td colspan="10">Carregando...</td></tr>
                            </tbody>
                        </table>`;
                        $(`.js-contract-parcels-list-${contract_id}`).html(tableHtml);
                        tableHtml = '';
                    }

                    let sumParcels = 0;

                    for(let i in res.data) {
                        let parcela = res.data[i];

                        let formaPgtoNome = '';
                        switch(parcela.FORMA_PAGTO) {
                            case 'C':
                                formaPgtoNome = 'Cartão de Crédito';
                                break;
                            case 'D':
                                formaPgtoNome = 'Cartão de Débito';
                                break;
                            case 'I':
                                formaPgtoNome = 'Dinheiro';
                                break;
                            case 'P':
                                formaPgtoNome = 'PIX';
                                break;
                            case 'T':
                                formaPgtoNome = 'Transferência';
                                break;
                        }

                        if (!isModal) {
                            tableHtml += `
                                <tr>
                                    <td data-label="ID">${parcela.ID}</td>
                                    <td data-label="Forma Pagto">${formaPgtoNome}</td>
                                    <td data-label="Qt Parcelas">${parcela.NRO_PARCELAS}</td>
                                    <td data-label="Vlr Parcela">${float2moeda(parcela.VLR_PARCELAS)}</td>
                                    <td data-label="Data Pagamento">${moment(parcela.DATA_PAGAMENTO_FORMATTED).format("DD/MM/YYYY")}</td>
                                    <td data-label="Parcela Paga?">${parcela.PARCELA_PAGA}</td>
                                </tr>
                            `;
                        } else {
                            tableHtml += `
                                <tr>
                                    <td data-label="ID">${parcela.ID}</td>
                                    <td data-label="Forma Pagto">
                                        <select class="form-select" id="contract_financial_installments_payment_method" name="contract_financial_installments_payment_method" data-parcel-id="${parcela.ID}" required>
                                            <option value="" disabled>-- Selecione --</option>
                                            <option value='C' ${formaPgtoNome == 'Cartão de Crédito' ? 'selected': ''}>Cartão de Crédito</option>
                                            <option value='D' ${formaPgtoNome == 'Cartão de Débito' ? 'selected': ''}>Cartão de Débito</option>
                                            <option value='I' ${formaPgtoNome == 'Dinheiro' ? 'selected': ''}>Dinheiro</option>
                                            <option value='P' ${formaPgtoNome == 'PIX' ? 'selected': ''}>PIX</option>
                                            <option value='T' ${formaPgtoNome == 'Transferência' ? 'selected': ''}>Transferência</option>
                                        </select>
                                    </td>
                                    <td data-label="Data Pagamento">
                                        <input type="date" class="form-control" id="contract_financial_installments_payment_date" name="contract_financial_installments_payment_date" value="${parcela.DATA_PAGAMENTO_FORMATTED}" data-parcel-id="${parcela.ID}" required>
                                    </td>
                                    <td data-label="Qt. Parcelas">
                                        <input type="number" class="form-control" id="contract_financial_installments_number" name="contract_financial_installments_number" value="${parcela.NRO_PARCELAS}" data-parcel-id="${parcela.ID}" required>
                                    </td>
                                    <td data-label="Vlr Parcela">
                                        <input type="number" class="form-control" id="contract_financial_installments_total" name="contract_financial_installments_total" value="${parcela.TOTAL}" data-parcel-id="${parcela.ID}" required>
                                    </td>
                                    <td data-label="Total">
                                        <input type="number" class="form-control" id="contract_financial_installments_value" name="contract_financial_installments_value" value="${parcela.VLR_PARCELAS}" data-parcel-id="${parcela.ID}" readonly required>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" id="contract_financial_installments_obs" name="contract_financial_installments_obs" value="${parcela.OBS}" data-parcel-id="${parcela.ID}" required>
                                    </td>
                                    <td data-label="Parcela Paga?">
                                        <select class="form-select" id="contract_financial_installments_paid" name="contract_financial_installments_paid" data-parcel-id="${parcela.ID}" required>
                                            <option value="" disabled>-- Selecione --</option>
                                            <option value="S" ${parcela.PARCELA_PAGA == 'S' ? 'selected': ''}>Sim</option>
                                            <option value="N" ${parcela.PARCELA_PAGA == 'N' ? 'selected': ''}>Não</option>
                                        </select>
                                    </td>
                                </tr>
                            `;
                        }

                        sumParcels += parseFloat(parcela.VLR_PARCELAS);
                    }

                    if (res.data.length === 0) {
                        tableHtml = `<tr><td colspan="11">Nenhuma parcela foi encontrada</td></tr>`;
                    }

                    if (!isModal) {
                        tableHtml += `<tr>
                            <td colspan="3"><strong>Total</strong></td>
                            <td>${float2moeda(sumParcels)}</td>
                            <td colspan="1"></td>
                        </tr>`;
                    } else {
                        // botão de salvar 
                        tableHtml += `<tr>
                            <td colspan="11">
                                <button class="btn btn-primary js-financial-contract-parcel-save-updates" id="contract_financial_installments_save">Salvar alterações</button>
                            </td>
                        </tr>`;
                    }

                    if (isModal) {
                        $('.js-financial-contract-installments-list').html(tableHtml);
                    } else {
                        $(`.js-contract-parcels-list-table-content-${contract_id}`).html(tableHtml);
                        $(`.js-contract-parcels-btn-${contract_id}`).prop('disabled', false);
                    }
                    //$('.js-financial-contract-installments-list').html(tableHtml);
                } else {
                    $(".modal-marketing-transfer-lead-dialog").block(window._loader.error);
                }
            },
            errorCallback: function(err) {
                $(".modal-marketing-transfer-lead-dialog").block(window._loader.error);
            }
        });
    }

    updateContractInstallments(contractId, parcelsData) {
        apiCall({
            method: 'POST',
            endpoint: 'api/v1/patient/contract/update_installments',
            data: {
                contractId: contractId,
                parcelsData: parcelsData
            },
            successCallback: function(res) {
                if (!res.error) {
                    window.toast({
                        text: 'Parcelas atualizadas com sucesso'
                    });
                    self.fetchContractInstallments(contractId);
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    });
                }
                $(".js-financial-contract-installments-form").unblock();
            },
            errorCallback: function(err) {
                window.toast({
                    error: true,
                    text: 'Erro ao atualizar parcelas'
                });
                $(".js-financial-contract-installments-form").unblock();
            }
        });
    }

}